import { Component, Input, Output, EventEmitter } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { FileService } from "../../shared/services/file.service";
import { PDFDocumentProxy } from 'ng2-pdf-viewer';
import { PdfWrapperComponent } from '../../shared/pdf-wrapper/pdf-wrapper.component';


@Component({
  standalone: false,
  selector: "app-pdf-wrapper-controls",
  templateUrl: "./pdf-wrapper-controls.component.html",
  styles: []
})
export class PdfWrapperControlsComponent {
  @Input() pdfWrapper: PdfWrapperComponent;
  @Input() showPrint = true;
  @Input() showSave = true;
  @Input() showZoomIn = true;
  @Input() showZoomOut = true;
  @Input() showRemove = false;
  @Input() disabled = false;
  @Output() OnRemoveFile = new EventEmitter<boolean>();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  pdfSrc: any;
  signing: boolean;
  signable: boolean;
  loading = true;
  pdfZoom = 1;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  pdf: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: any;
  page = 1;
  isLoaded = false;
  size: number;

  constructor(
    private route: ActivatedRoute,
    private fileService: FileService
  ) {
  }

  zoom(zoomSize: number) {
    this.pdfWrapper.zoom(zoomSize);
  }

  printpdf() {
    this.pdfWrapper.printpdf();
  }

  removeFile() {
    this.OnRemoveFile.emit(true);
  }

  showPages() {
    this.pdfWrapper.showAllPages();
  }

  saveFile() {
    this.pdfWrapper.saveFile();
  }

  incrementPage(amount: number) {
    this.pdfWrapper.incrementPage(amount);
  }

  afterLoadComplete(pdf: PDFDocumentProxy) {
    this.pdfWrapper.afterLoadComplete(pdf);
  }

  getInt(value: number): number {
    return Math.round(value);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onError(error: any) {
    this.error = error;
  }

  setPassword(password: string) {
    let newSrc;

    if (this.pdfSrc instanceof ArrayBuffer) {
      newSrc = {data: this.pdfSrc};
    } else if (typeof this.pdfSrc === 'string') {
      newSrc = {url: this.pdfSrc};
    } else {
      newSrc = {...this.pdfSrc};
    }

    newSrc.password = password;

    this.pdfSrc = newSrc;
  }

}
